// extracted by mini-css-extract-plugin
export default {"dynamic-consents-container":"static-React-Applications-DynamicRegistration-Pages-Consents-___styles-module__dynamic-consents-container"};